import type { INotification } from '../molecules/Notifications/INotification';
import { sendNotification } from './notifications';

type CopyNotice = Pick<INotification, 'title' | 'message'>;

export interface ICopyTextNotices {
    /** @default { title: 'Скопировано' } */
    success?: CopyNotice;
    /** @default COPY_FAILURE */
    failure?: CopyNotice;
}

/** Причина отказа словами пользователя: текст ошибки браузера («Document is not focused») ему ничего не скажет. */
export const COPY_FAILURE_REASON = 'Браузер не дал доступа к буферу обмена — скопируйте вручную.';

export const COPY_FAILURE: Readonly<CopyNotice> = { title: 'Не удалось скопировать', message: COPY_FAILURE_REASON };

/**
 * Копирует текст в буфер и сообщает итог тостом: успех — зелёным, отказ (нет Clipboard API вне HTTPS, страница без
 * фокуса, запрет браузера) — красным. Возвращает, удалось ли.
 */
export const copyText = async (text: string, notices: ICopyTextNotices = {}): Promise<boolean> => {
    try {
        await navigator.clipboard.writeText(text);
    } catch {
        sendNotification({ ...(notices.failure ?? COPY_FAILURE), variant: 'red' }, 5000);
        return false;
    }
    sendNotification({ ...(notices.success ?? { title: 'Скопировано' }), variant: 'green' }, 1500);
    return true;
};
